import { AppDispatch } from "../../redux/store.ts";
import { Requirement, Status } from "../../redux/interfaces/folder.types.ts";
import {
  setActivePanels,
  setActiveRequirement,
} from "../../redux/slices/vaultSlice.ts";

interface Params {
  dispatch: AppDispatch;
  activeRequirement: Requirement | null;
  requirements: Requirement[];
}

export const activeNextPendingRequirement = ({
  dispatch,
  activeRequirement,
  requirements,
}: Params): void => {
  const nextPendingRequirement = requirements.find(
    (req) =>
      req.status === Status.PendingUpload && req.id !== activeRequirement?.id,
  );

  if (nextPendingRequirement) {
    dispatch(setActivePanels([nextPendingRequirement.id]));
    dispatch(setActiveRequirement(nextPendingRequirement));
  }
};
